  //-----------------------
  // React basic Components
  //-----------------------
  import React                                               from "react";
  import PropTypes                                           from "prop-types";
  import { NavLink }                                         from "react-router-dom";
  import { connect }                                         from "react-redux";
  //-----------------------------
  // @material-ui/core components
  //-----------------------------
  import withStyles                                          from "@material-ui/core/styles/withStyles";
  import Button                                              from '@material-ui/core/Button';
  import TextField                                           from '@material-ui/core/TextField';
  import Checkbox                                            from '@material-ui/core/Checkbox';
//import Link                                                from '@material-ui/core/Link';
//import Radio                                               from '@material-ui/core/Radio';
//import RadioGroup                                          from '@material-ui/core/RadioGroup';
  import CircularProgress                                    from "@material-ui/core/CircularProgress";
//import AccountCircleIcon                                   from "@material-ui/icons/AccountCircle";
  import Dialog                                              from '@material-ui/core/Dialog';
  import DialogActions                                       from '@material-ui/core/DialogActions';
  import DialogContent                                       from '@material-ui/core/DialogContent';
  import DialogContentText                                   from '@material-ui/core/DialogContentText';
  import DialogTitle                                         from '@material-ui/core/DialogTitle';
  import Slide                                               from '@material-ui/core/Slide';
  import FormControlLabel                                    from '@material-ui/core/FormControlLabel';
//import InputLabel                                          from '@material-ui/core/InputLabel';
//import MenuItem                                            from '@material-ui/core/MenuItem';
//import FormHelperText                                      from '@material-ui/core/FormHelperText';
//import FormControl                                         from '@material-ui/core/FormControl';
//import Select                                              from '@material-ui/core/Select';
//import Autocomplete                                        from '@material-ui/lab/Autocomplete';
  //[SNACKBAR]
  import Snackbar                                            from '@material-ui/core/Snackbar';
  import MuiAlert                                            from '@material-ui/lab/Alert';
  //------------------
  // Custom components
  //------------------
  import GridContainer                                       from "components/Grid/GridContainer.jsx";
  import GridItem                                            from "components/Grid/GridItem.jsx";
  import CustomButton                                        from "components/CustomButtons/Button.jsx";
//import CustomInput                                         from "components/CustomInput/CustomInput.jsx";
//import CustomDropdown                                      from "components/CustomDropdown/CustomDropdown.jsx";
//import Typography                                          from '@material-ui/core/Typography';
  //--------------------
  // 3rd party libraries
  //--------------------
  import Cookies                                             from 'js-cookie';
  //------------
  // WebServices
  //------------
  import { history }                                         from "../../_helpers";
  import { api }                                             from "../../_constants";
  import { wu_StaticDataService }                            from "../../_services";
  import { wu_Utilities }                                    from "../../_services";
  import { wu_BillsService }                                 from "../../_services";
  import { wu_TransactionFlow }                              from "../../_services";
  import { wu_ProfileService }                               from "../../_services";
  //------
  // Style
  //------
  import BillsPaymentReviewStyle                                from "./BillsPaymentReviewStyle.jsx";
  //-------
  // images
  //-------
//import logo                                                from "assets/img/wu/WU_CONTENT_main_symbol_left.svg";

  import Bills_Company_Placeholder                           from "assets/img/wu/Bills_Company_Placeholder.svg";

//import WU_Card_logos_visa                                  from "assets/img/wu/cards/vbv.jpg";
//import WU_Card_logos_mastercard                            from "assets/img/wu/cards/sc_68x37.gif";
  //----------
  // variables
  //----------
  const filename = "BillsPaymentReview ";
  const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
  });
  //[SNACKBAR]
  function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
  }

  //[Lockers]
  var BillsPaymentReview_continue_locked = true;

class BillsPaymentReview extends React.Component {
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Basic Methods-------------------------------------
  //----------------------------------------------------------------------------------------------------
  constructor(props) {
    let methName = filename+"constructor ";
    if(api.print_logs){console.log(methName+props);}

    super(props);
    this.state = {
      dialog_msg                                           : "",
      dialog_isOpen                                        : false,

      //[DialogSpinner]
      dialog200_msg                                        : "",
      dialog200_isOpen                                     : false,

      viewPleaseWait_hidden                                : true,

      //[SNACKBAR]
      Snackbar_textField_open                              : false,
      Snackbar_textField_msg                               : "",

      lbl_status                                             : "",
      lbl_date                                               : "",
      imv_logo                                               : "",

      lbl_billsKeyVal01_isHidden                             : true,
      lbl_billsKeyVal02_isHidden                             : true,
      lbl_billsKeyVal03_isHidden                             : true,
      lbl_billsKeyVal04_isHidden                             : true,
      lbl_billsKeyVal05_isHidden                             : true,
      lbl_billsKeyVal06_isHidden                             : true,
      lbl_billsKeyVal07_isHidden                             : true,
      lbl_billsKeyVal08_isHidden                             : true,
      lbl_billsKeyVal09_isHidden                             : true,

      textField1                                           : "",
      textField1_hasError                                  : false,

      ShouldSaveCard                                       : false,

      userAcceptedTerms                                    : false,

      merchantReference                                    : "", //Peiraius Payment info
      user                                                 : "",
      merchantId                                           : "",
      posId                                                : "",
      acquirerId                                           : "",
      LanguageCode                                         : "",

      //popup goBack
      dialog_goBack_msg                                      : "",
      dialog_goBack_isOpen                                   : false,
      //popup gotoController
      dialog_gotoController_msg                              : "",
      dialog_gotoController_isOpen                           : false,
    };
    //------------
    //translations
    //------------
    this.texts_gr = wu_StaticDataService.wu_getLocales_gr({});
    this.texts_en = wu_StaticDataService.wu_getLocales_en({});
    //--------
    //bindings
    //--------
    this.verifyGenericItem                                            = this.verifyGenericItem.bind(this);
    this.dialog_handleClose                                           = this.dialog_handleClose.bind(this);
    this.startSpinners                                                = this.startSpinners.bind(this);
    this.stopSpinners                                                 = this.stopSpinners.bind(this);

    //[Lockers]
    this.isLockersActive                                              = this.isLockersActive.bind(this);
    this.startLockers                                                 = this.startLockers.bind(this);
    this.stopLockers                                                  = this.stopLockers.bind(this);

    //[DialogSpinner]
    this.dialog200_handleOpen                                         = this.dialog200_handleOpen.bind(this);
    this.dialog200_handleClose                                        = this.dialog200_handleClose.bind(this);

    //[goBack]
    this.goBack                                                       = this.goBack.bind(this);

    //[SNACKBAR]for
    this.Snackbar_textField_handleOpen                                = this.Snackbar_textField_handleOpen.bind(this);
    this.Snackbar_textField_handleClose                               = this.Snackbar_textField_handleClose.bind(this);

    this.makeScreenTranslations                                       = this.makeScreenTranslations.bind(this);

    this.btn_proceed_act_card_normal                                  = this.btn_proceed_act_card_normal.bind(this);
    this.btn_proceed_act_card_normal_isDisabled                       = this.btn_proceed_act_card_normal_isDisabled.bind(this);
    this.makeHTTPConn_proceed_card_normal                             = this.makeHTTPConn_proceed_card_normal.bind(this);
    this.btn_proceed_act_card_tokenized                               = this.btn_proceed_act_card_tokenized.bind(this);
    this.btn_proceed_act_card_tokenized_isDisabled                    = this.btn_proceed_act_card_tokenized_isDisabled.bind(this);
    this.makeHTTPConn_proceed_card_tokenized                          = this.makeHTTPConn_proceed_card_tokenized.bind(this);

    this.handleCheckBoxClick_saveNewCard                              = this.handleCheckBoxClick_saveNewCard.bind(this);

    this.handleCheckBoxClick_userAcceptedTerms                        = this.handleCheckBoxClick_userAcceptedTerms.bind(this);

    this.process_CategoriesCompaniesObject                            = this.process_CategoriesCompaniesObject.bind(this);

    this.load_localStorage_to_cookies                                 = this.load_localStorage_to_cookies.bind(this);

    //popup goBack
    this.dialog_goBack_handleOpen                                     = this.dialog_goBack_handleOpen.bind(this);
    this.dialog_goBack_btn_OK                                         = this.dialog_goBack_btn_OK.bind(this);
    //popup gotoController
    this.dialog_gotoController_handleOpen                             = this.dialog_gotoController_handleOpen.bind(this);
    this.dialog_gotoController_btn_OK                                 = this.dialog_gotoController_btn_OK.bind(this);
  }
  //----------------------------------------------------------------------------------------------------
  componentWillMount() {
    let methName = filename+"componentWillMount ";
    if(api.print_logs){console.log(methName);}

    localStorage.setItem("prev_view", localStorage.getItem("curr_view"));
    localStorage.setItem("curr_view", filename);
    if(api.print_logs){console.log(methName+"++++++++++++++++++++++++++++++++++++++++++++++++++");}
    if(api.print_logs){console.log(methName+localStorage.getItem("prev_view")+" -> "+localStorage.getItem("curr_view"));}
    if(api.print_logs){console.log(methName+"++++++++++++++++++++++++++++++++++++++++++++++++++");}

    //[Lockers]
    this.stopLockers();

    //Do nothing if---get
    if(localStorage.getItem("prev_view").trim()==="SettingsPrivacy"    ||
       localStorage.getItem("prev_view").trim()==="SettingsTermsBills" ){
      if(api.print_logs){console.log("Do nothing if...");}
      try{ this.setState(JSON.parse(localStorage.getItem(filename.trim()))); }catch(err){console.log(methName+"err="+JSON.stringify(err));}
      return;
    }
    //++++++++++++++++++++++
    //webapp session timeout
    //++++++++++++++++++++++
    if(wu_Utilities.checkIfUserIsLoggedIn()){
      wu_Utilities.update_uilatstats();
      if(!wu_Utilities.check_uilatstats(api.uilatstats_inactivity_mins)){ wu_Utilities.LogoutUserFromApp(filename); history.push(wu_Utilities.getNavigationURLs("LoginPage")); return; }
    }
    if(!wu_Utilities.checkIfUserIsLoggedIn()){
      wu_Utilities.LogoutUserFromApp(filename); history.push(wu_Utilities.getNavigationURLs("LoginPage")); return;
    }
    //---------------------
    //newCustomer filtering--load Contoller---Exclude(LIGHT)
    //---------------------
    if(api.new_registration_enabled){
      let parserObject_validatecustomer = {};
      try{ parserObject_validatecustomer = JSON.parse(localStorage.getItem("parserObject_validatecustomer"));}catch(err){console.log(methName+'err='+err);}
      let customerLevel = wu_Utilities.textDecisions_customerLevel(api.print_logs,parserObject_validatecustomer);
      if(customerLevel==="LIGHT"){ try {localStorage.setItem("newRegistrationFlow","newCustomer");   }catch(err){;} history.push(wu_Utilities.getNavigationURLs("RegisterLightInfo")); return; }
    //if(customerLevel==="BP")   { try {localStorage.setItem("newRegistrationFlow","upgradeAccount");}catch(err){;} history.push(wu_Utilities.getNavigationURLs("RegisterLightInfo")); return; }
    }

    console.log("payWithCardMethod="+localStorage.getItem("payWithCardMethod"))
    //---------------------------------
    //Clear Previous Payment(if exists)
    //---------------------------------
    this.setState({
      merchantReference                                    : "",
      user                                                 : "",
      merchantId                                           : "",
      posId                                                : "",
      acquirerId                                           : "",
      LanguageCode                                         : "",
    });
    //---------------------------
    //Peiraius Private Mode Issue
    //---------------------------
    this.load_cookies_to_localStorage();
    //wu_Utilities.printSomeValuesFromLocalStorage();

    //-------------------------
    //wu_getCategoriesCompanies---CACHED
    //-------------------------
    let retrieveWSData_getCategoriesCompanies = wu_BillsService.wu_should_getCategoriesCompanies();
    if(api.print_logs){console.log("retrieveWSData_getCategoriesCompanies="+retrieveWSData_getCategoriesCompanies);}
    if(retrieveWSData_getCategoriesCompanies){
      wu_BillsService
      .wu_getCategoriesCompanies({})
      .then(res => {
        if(localStorage.getItem("curr_view").trim()!=="BillsPaymentReview"){if(api.print_logs){console.log(methName+"5A11");}return;}//5A11
        this.process_CategoriesCompaniesObject();
        this.makeHTTPConn();
      })
      .catch(err => {
        console.log(methName+"err="+err);
      });
    }
    else{
      try{
        //let res = JSON.parse(localStorage.getItem("categoriescompanies"));
        this.process_CategoriesCompaniesObject();
        this.makeHTTPConn();
      }catch(err){
        console.log(methName+'err='+err);
      }
    }
  }
  //----------------------------------------------------------------------------------------------------
  flow_decision(){
    let methName = filename+"flow_decision ";
    if(api.print_logs){console.log(methName);}

    let bills_billsHistoryDetail_FLOW_localStorage = "";
    try{ bills_billsHistoryDetail_FLOW_localStorage = localStorage.getItem("bills_billsHistoryDetail_FLOW").trim(); } catch(err){ console.log(methName+"err="+err); }
    let bills_billsHistoryDetail_FLOW_cookies = "";
    try{ bills_billsHistoryDetail_FLOW_cookies = Cookies.get('bills_billsHistoryDetail_FLOW') } catch(err){ console.log(methName+"err="+err); }
    if(api.print_logs){console.log("[localStorage] bills_billsHistoryDetail_FLOW = "+bills_billsHistoryDetail_FLOW_localStorage);}
    if(api.print_logs){console.log("[cookies]      bills_billsHistoryDetail_FLOW = "+bills_billsHistoryDetail_FLOW_cookies);}

    if(bills_billsHistoryDetail_FLOW_localStorage==="bills_billsHistoryDetail_FLOW_PAYMENT" || bills_billsHistoryDetail_FLOW_cookies==="bills_billsHistoryDetail_FLOW_PAYMENT"){
      return "bills_billsHistoryDetail_FLOW_PAYMENT";
    }
    else{
      return "bills_billsHistoryDetail_FLOW_HISTORY";
    }
  }
  //----------------------------------------------------------------------------------------------------
  makeHTTPConn() {
    let methName = filename+"makeHTTPConn ";
    if(api.print_logs){console.log(methName);}

    //var parserObject_bills_billsHistoryDetail_res = null;
    //try{ parserObject_bills_billsHistoryDetail_res = JSON.parse(localStorage.getItem("parserObject_bills_billsHistoryDetail_res"));}catch(err){console.log(methName+'err='+err);}

    if(this.state.dialog200_isOpen===false){this.dialog200_handleOpen(this.NSInforString("please_wait"));} //start DialogSpinner only if network connection will take place
    //-------------------
    //wu_validatecustomer
    //-------------------
    wu_ProfileService
    .wu_validatecustomer({})
    .then(res => {
      if(localStorage.getItem("curr_view").trim()!=="BillsPaymentReview"){if(api.print_logs){console.log(methName+"5A11");}return;}//5A11
      localStorage.setItem("parserObject_validatecustomer",JSON.stringify(res.customer));

      if(this.flow_decision()==="bills_billsHistoryDetail_FLOW_HISTORY"){
        this.stopLockers();this.stopSpinners();this.dialog200_handleClose();//stop DialogSpinner = YES
        this.makeScreenTranslations();
      }
      else{
        if(localStorage.getItem("payWithCardMethod")==="payWithCardMethod_Tokenized" || Cookies.get('wuwb4c_payWithCardMethod')==="Tokenized"){
          Cookies.set('wuwb4c_payWithCardMethod',"");
          localStorage.setItem("triggerRefresh_Bills","true");          localStorage.setItem("triggerRefresh_Bills_LastDate", new Date());
          localStorage.setItem("triggerRefresh_BillsHistory","true");   localStorage.setItem("triggerRefresh_BillsHistory_LastDate", new Date());
          localStorage.setItem("triggerRefresh_BillsFavorites","true"); localStorage.setItem("triggerRefresh_BillsFavorites_LastDate", new Date());
          this.stopLockers();this.stopSpinners();this.dialog200_handleClose();//stop DialogSpinner = YES
          this.makeScreenTranslations();
        }
        else{
          Cookies.set('wuwb4c_payWithCardMethod',"");
          this.makeHTTPConn_finalizeOutbound();
        }
      }
    })
    .catch(err => {
      this.stopLockers();this.stopSpinners();this.dialog200_handleClose();//stop DialogSpinner = YES
      console.log(methName+"err="+JSON.stringify(err));
      if(err && err.returnCode && err.returnCode!==0){ if(err.returnCode===100){console.log("!!!!!!!!!!Logout("+filename+"-02)!!!!!!!!!!");wu_Utilities.LogoutUserFromApp(filename);history.push(wu_Utilities.getNavigationURLs("LoginPage"));} this.dialog_handleOpen(err.returnText,"NET"); }
      else                                           { this.dialog_handleOpen(this.NSInforString("networkerror"),"NET"); }
    });
  }
  //----------------------------------------------------------------------------------------------------
  makeHTTPConn_finalizeOutbound() {
    let methName = filename+"makeHTTPConn_finalizeOutbound ";
    if(api.print_logs){console.log(methName);}

    setTimeout(function() { //Start the timer
      //----------------
      //finalizeoutbound
      //----------------
      let transactionID = 0;
      try{ transactionID = parseInt(localStorage.getItem("transId")); }catch(err){console.log(methName+"err="+JSON.stringify(err));}

      let parserObject_bills_finalizeoutbound_req = {};
      if(Cookies.get('wuwb4c_cardPaymentStatus')==="success"){
        parserObject_bills_finalizeoutbound_req["wbTransactionID"]       = transactionID;
        //
        parserObject_bills_finalizeoutbound_req["cardPayment"]           = "success";
        //basic attributes
        parserObject_bills_finalizeoutbound_req["TransactionId"]         = Cookies.get('wuwb4c_TransactionId');
        parserObject_bills_finalizeoutbound_req["SupportReferenceID"]    = Cookies.get('wuwb4c_SupportReferenceID');
        parserObject_bills_finalizeoutbound_req["ApprovalCode"]          = Cookies.get('wuwb4c_ApprovalCode');
        parserObject_bills_finalizeoutbound_req["PackageNo"]             = Cookies.get('wuwb4c_PackageNo');
        parserObject_bills_finalizeoutbound_req["ResponseCode"]          = Cookies.get('wuwb4c_ResponseCode');
        parserObject_bills_finalizeoutbound_req["RetrievalRef"]          = Cookies.get('wuwb4c_RetrievalRef');
        parserObject_bills_finalizeoutbound_req["ResultCode"]            = Cookies.get('wuwb4c_ResultCode');
        //extra attributes
        parserObject_bills_finalizeoutbound_req["ResultDescription"]     = Cookies.get('wuwb4c_ResultDescription');
        parserObject_bills_finalizeoutbound_req["StatusFlag"]            = Cookies.get('wuwb4c_StatusFlag');
        parserObject_bills_finalizeoutbound_req["ResponseDescription"]   = Cookies.get('wuwb4c_ResponseDescription');
        parserObject_bills_finalizeoutbound_req["MerchantRef"]           = Cookies.get('wuwb4c_MerchantRef');
        parserObject_bills_finalizeoutbound_req["TransDatetime"]         = Cookies.get('wuwb4c_TransDatetime');
      }
      else{
        parserObject_bills_finalizeoutbound_req["wbTransactionID"]       = transactionID;
        //
        parserObject_bills_finalizeoutbound_req["cardPayment"]           = "failure";
        //basic attributes
        parserObject_bills_finalizeoutbound_req["TransactionId"]         = Cookies.get('wuwb4c_TransactionId');
        parserObject_bills_finalizeoutbound_req["SupportReferenceID"]    = Cookies.get('wuwb4c_SupportReferenceID');
        parserObject_bills_finalizeoutbound_req["ApprovalCode"]          = Cookies.get('wuwb4c_ApprovalCode');
        parserObject_bills_finalizeoutbound_req["PackageNo"]             = Cookies.get('wuwb4c_PackageNo');
        parserObject_bills_finalizeoutbound_req["ResponseCode"]          = Cookies.get('wuwb4c_ResponseCode');
        parserObject_bills_finalizeoutbound_req["RetrievalRef"]          = Cookies.get('wuwb4c_RetrievalRef');
        parserObject_bills_finalizeoutbound_req["ResultCode"]            = Cookies.get('wuwb4c_ResultCode');
        //extra attributes
        parserObject_bills_finalizeoutbound_req["ResultDescription"]     = Cookies.get('wuwb4c_ResultDescription');
        parserObject_bills_finalizeoutbound_req["StatusFlag"]            = Cookies.get('wuwb4c_StatusFlag');
        parserObject_bills_finalizeoutbound_req["ResponseDescription"]   = Cookies.get('wuwb4c_ResponseDescription');
        parserObject_bills_finalizeoutbound_req["MerchantRef"]           = Cookies.get('wuwb4c_MerchantRef');
        parserObject_bills_finalizeoutbound_req["TransDatetime"]         = Cookies.get('wuwb4c_TransDatetime');
      }
      localStorage.setItem("triggerRefresh_Bills","true");          localStorage.setItem("triggerRefresh_Bills_LastDate", new Date());
      localStorage.setItem("triggerRefresh_BillsHistory","true");   localStorage.setItem("triggerRefresh_BillsHistory_LastDate", new Date());
      localStorage.setItem("triggerRefresh_BillsFavorites","true"); localStorage.setItem("triggerRefresh_BillsFavorites_LastDate", new Date());
      //-------------------
      //wu_finalizeoutbound
      //-------------------
      wu_BillsService
      .wu_bills_payment_finalizeOutbound(parserObject_bills_finalizeoutbound_req)
      .then(res => {
        if(localStorage.getItem("curr_view").trim()!=="BillsPaymentReview"){if(api.print_logs){console.log(methName+"5A11");}return;}//5A11
        this.stopLockers();this.stopSpinners();this.dialog200_handleClose();//stop DialogSpinner = YES
        this.makeScreenTranslations();
      })
      .catch(err => {
        //this.clear_cookies_not_needed();
        this.stopSpinners();this.dialog200_handleClose();//stop DialogSpinner = YES
        console.log(methName+"err="+JSON.stringify(err));
        if(err && err.returnCode && err.returnCode!==0){
          if(err.returnCode===100){console.log("!!!!!!!!!!Logout("+filename+"-02)!!!!!!!!!!");wu_Utilities.LogoutUserFromApp(filename);history.push(wu_Utilities.getNavigationURLs("LoginPage"));}
          this.dialog_handleOpen(err.returnText);
        }
      });
    }.bind(this), 500);
  }
  //----------------------------------------------------------------------------------------------------
  componentDidMount() {
    let methName = filename+"componentDidMount ";
    if(api.print_logs){console.log(methName);}
  }
  //----------------------------------------------------------------------------------------------------
  componentWillUnmount() {
    let methName = filename+"componentWillUnmount ";
    if(api.print_logs){console.log(methName);}

    localStorage.setItem(filename.trim(), JSON.stringify(this.state));//Do nothing if---set
  }
  //----------------------------------------------------------------------------------------------------
  render() {
    let methName = filename+"render ";
    if(api.print_logs){console.log(methName);}

    const classes = this.props.classes;

    const path_SettingsTermsBills = api.webapp_path+"/SettingsTermsBills";
    const path_SettingsPrivacy    = api.webapp_path+"/SettingsPrivacy";

    //let moreURL = (localStorage.getItem("lang")==="en") ? "https://www.westernunion.gr/en/fraud-awareness/" : "https://www.westernunion.gr/enimerosi-apati/";

    return (
      <div className={classes.container}>
        <GridContainer justify="center">
          <GridItem xs={12} sm={api.columns_bills_sm} md={api.columns_bills_md}>
            {/* ------------------------- */}
            {/* ----------Comapny logo--- */}
            {/* ------------------------- */}
            <GridContainer justify="center">
              <GridItem xs={12} sm={12} md={12}>
                <div className={classes.BillsPaymentReviewStyle_lbl_status}>{this.state.lbl_status}</div>
              </GridItem>
              <GridItem xs={12} sm={12} md={12}>
                <div className={classes.BillsPaymentReviewStyle_lbl_date}>{this.state.lbl_date}</div>
              </GridItem>
              {this.state.imv_logo !== "" && this.state.imv_logo.indexOf(".png") > -1 ?
              <GridItem xs={2} sm={2} md={2}>
                <GridContainer justify="center">
                  <div className={classes.logo}><img src={this.state.imv_logo} alt="" /></div>
                </GridContainer>
              </GridItem>
              :
              (
              <GridItem xs={2} sm={2} md={2}>
                <GridContainer justify="center">
                  <div className={classes.companyIcon}><img src={Bills_Company_Placeholder} alt="companyIcon" /></div>
                </GridContainer>
              </GridItem>
              )}
            </GridContainer>
            {/* ------------------------- */}
            {/* ----------[SUMMARY]------ */}
            {/* ------------------------- */}
            <div style={{ marginTop:10, marginBottom:20, "backgroundColor":"#EAEBED", padding:"0.8rem", "border-radius": "10px" }}>
              <GridContainer justify="center">
                <GridItem xs={12} sm={12} md={12}>
                  {this.state.lbl_billsKeyVal01_isHidden === true ? ( "" ) : (
                    <GridContainer justify="center" style={{ marginTop:10}}>
                      <GridItem xs={5} sm={5} md={5}><div className={classes.viewRN_key}>{this.state.lbl_billsKey01}</div></GridItem>
                      <GridItem xs={7} sm={7} md={7}><div className={classes.viewRN_val}>{this.state.lbl_billsVal01}</div></GridItem>
                    </GridContainer>
                  )}
                  {this.state.lbl_billsKeyVal02_isHidden === true ? ( "" ) : (
                    <GridContainer justify="center" style={{ marginTop:10}}>
                      <GridItem xs={5} sm={5} md={5}><div className={classes.viewRN_key}>{this.state.lbl_billsKey02}</div></GridItem>
                      <GridItem xs={7} sm={7} md={7}><div className={classes.viewRN_val}>{this.state.lbl_billsVal02}</div></GridItem>
                    </GridContainer>
                  )}
                  {this.state.lbl_billsKeyVal03_isHidden === true ? ( "" ) : (
                    <GridContainer justify="center" style={{ marginTop:10}}>
                      <GridItem xs={5} sm={5} md={5}><div className={classes.viewRN_key}>{this.state.lbl_billsKey03}</div></GridItem>
                      <GridItem xs={7} sm={7} md={7}><div className={classes.viewRN_val}>{this.state.lbl_billsVal03}</div></GridItem>
                    </GridContainer>
                  )}
                  {this.state.lbl_billsKeyVal04_isHidden === true ? ( "" ) : (
                    <GridContainer justify="center" style={{ marginTop:10}}>
                      <GridItem xs={5} sm={5} md={5}><div className={classes.viewRN_key}>{this.state.lbl_billsKey04}</div></GridItem>
                      <GridItem xs={7} sm={7} md={7}><div className={classes.viewRN_val}>{this.state.lbl_billsVal04}</div></GridItem>
                    </GridContainer>
                  )}
                  {this.state.lbl_billsKeyVal05_isHidden === true ? ( "" ) : (
                    <GridContainer justify="center" style={{ marginTop:10}}>
                      <GridItem xs={5} sm={5} md={5}><div className={classes.viewRN_key}>{this.state.lbl_billsKey05}</div></GridItem>
                      <GridItem xs={7} sm={7} md={7}><div className={classes.viewRN_val}>{this.state.lbl_billsVal05}</div></GridItem>
                    </GridContainer>
                  )}
                  {this.state.lbl_billsKeyVal06_isHidden === true ? ( "" ) : (
                    <GridContainer justify="center" style={{ marginTop:10}}>
                      <GridItem xs={5} sm={5} md={5}><div className={classes.viewRN_key}>{this.state.lbl_billsKey06}</div></GridItem>
                      <GridItem xs={7} sm={7} md={7}><div className={classes.viewRN_val}>{this.state.lbl_billsVal06}</div></GridItem>
                    </GridContainer>
                  )}
                  {this.state.lbl_billsKeyVal07_isHidden === true ? ( "" ) : (
                    <GridContainer justify="center" style={{ marginTop:10}}>
                      <GridItem xs={5} sm={5} md={5}><div className={classes.viewRN_key}>{this.state.lbl_billsKey07}</div></GridItem>
                      <GridItem xs={7} sm={7} md={7}><div className={classes.viewRN_val}>{this.state.lbl_billsVal07}</div></GridItem>
                    </GridContainer>
                  )}
                  {this.state.lbl_billsKeyVal08_isHidden === true ? ( "" ) : (
                    <GridContainer justify="center" style={{ marginTop:10}}>
                      <GridItem xs={5} sm={5} md={5}><div className={classes.viewRN_key}>{this.state.lbl_billsKey08}</div></GridItem>
                      <GridItem xs={7} sm={7} md={7}><div className={classes.viewRN_val}>{this.state.lbl_billsVal08}</div></GridItem>
                    </GridContainer>
                  )}
                  {this.state.lbl_billsKeyVal09_isHidden === true ? ( "" ) : (
                    <GridContainer justify="center" style={{ marginTop:10}}>
                      <GridItem xs={5} sm={5} md={5}><div className={classes.viewRN_key}>{this.state.lbl_billsKey09}</div></GridItem>
                      <GridItem xs={7} sm={7} md={7}><div className={classes.viewRN_val}>{this.state.lbl_billsVal09}</div></GridItem>
                    </GridContainer>
                  )}
                </GridItem>
              </GridContainer>
            </div>
            {/* --------------------------------- */}
            {/* ----------[Card Holder]---------- */}
            {/* --------------------------------- */}
            {localStorage.getItem("payWithCardMethod")==="payWithCardMethod_Normal" ?
            (
              <div style={{ marginTop:25, marginBottom:15 }}>
                <GridContainer justify="center">
                  <GridItem xs={12} sm={12} md={12}>
                      <div className={classes.BillsPaymentReview_lbl_cardHolderName}>{this.NSInforString("BillsPaymentReview_lbl_cardHolderName")}</div>
                  </GridItem>
                  <GridItem xs={12} sm={12} md={12}>
                    <TextField
                      fullWidth
                      error={this.state.textField1_hasError}
                      className={classes.textField1}
                      id="textField1"
                      label={this.NSInforString("BillsPaymentReview_plh1")}
                      value={this.state.textField1}
                      InputProps={{
                        fullWidth: true,
                        onChange: event => this.change(event, "textField1"),
                        type: "text"
                      }}
                    />
                  </GridItem>
                </GridContainer>
              </div>
            ) : ( "" )
            }
            {/* --------------------------------- */}
            {/* ----------[Save New Card]-------- */}
            {/* --------------------------------- */}
            {localStorage.getItem("payWithCardMethod")==="payWithCardMethod_Normal" ?
            (
            <GridContainer justify="center" style={{ marginTop:0}}>
              <GridItem xs={2} sm={1} md={1}>
                <FormControlLabel
                  control={
                    <Checkbox
                      onChange={this.handleCheckBoxClick_saveNewCard}
                      value="checkedA"
                      inputProps={{ 'aria-label': 'Checkbox A' }}
                    />
                  }
                  label=""
                />
              </GridItem>
              <GridItem xs={10} sm={11} md={11}>
                <div className={classes.BillsPaymentReview_ViewCardSave_lbl_info}>{this.NSInforString("BillsPaymentReview_ViewCardSave_lbl_info")}</div>
              </GridItem>
              {/* <GridItem xs={12} sm={12} md={12} style={{ marginTop:0, marginBottom:0}}>
                <TextField
                  fullWidth
                  id="standard-read-only-input1"
                  label=""
                  value=""
                  InputProps={{ fullWidth:true, readOnly:true, style: {height:1} }}
                />
              </GridItem> */}
            </GridContainer>
            ) : ( "" )
            }
            {/* ------------------------- */}
            {/* ----------[Fraud]-------- */}
            {/* ------------------------- */}
            {/* <div style={{ marginTop: 20 }}>
            <GridContainer justify="center">
              <GridItem xs={12} sm={12} md={12}>
                <div className={classes.BillsPaymentReview_lbl_fraud1}>{this.NSInforString("BillsPaymentReview_lbl_fraud1")}</div>
              </GridItem>
              <GridItem xs={12} sm={12} md={12}>
                <div className={classes.BillsPaymentReview_lbl_fraud2}>{this.NSInforString("BillsPaymentReview_lbl_fraud2")}</div>
              </GridItem>
              <GridItem xs={12} sm={12} md={12}>
                <div className={classes.BillsPaymentReview_lbl_fraud3}>{this.NSInforString("BillsPaymentReview_lbl_fraud3")}<a href={moreURL} target="_blank" rel="noopener noreferrer"><u>{this.NSInforString("BillsPaymentReview_lbl_fraud4")}</u></a></div>
              </GridItem>
            </GridContainer>
            </div> */}
            {/* ------------------------- */}
            {/* ----------[Terms]-------- */}
            {/* ------------------------- */}
            {localStorage.getItem("lang")==="en" ?
            (
            <GridContainer justify="center" style={{ marginTop:10}}>
              <GridItem xs={2} sm={1} md={1}>
                <FormControlLabel
                  control={
                    <Checkbox
                      onChange={this.handleCheckBoxClick_userAcceptedTerms}
                      value="checkedA"
                      inputProps={{ 'aria-label': 'Checkbox A' }}
                    />
                  }
                  label=""
                />
              </GridItem>
              <GridItem xs={10} sm={11} md={11}>
                <div style={{ paddingLeft:0, marginLeft:-10, textAlign:"left" }}><span style={{fontFamily:"Helvetica", fontWeight:"300",  color:"#1A1A1A", marginTop:0}}>I have read and accept the <NavLink activeClassName="active" exact to={path_SettingsTermsBills}>Terms & Conditions</NavLink> and I have been informed about the <NavLink activeClassName="active" exact to={path_SettingsPrivacy}>Privacy Statement</NavLink></span></div>
              </GridItem>
            </GridContainer>
            ) :
            (
              <GridContainer justify="center" style={{ marginTop:10}}>
                <GridItem xs={2} sm={1} md={1}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        onChange={this.handleCheckBoxClick_userAcceptedTerms}
                        value="checkedA"
                        inputProps={{ 'aria-label': 'Checkbox A' }}
                      />
                    }
                    label=""
                  />
                </GridItem>
                <GridItem xs={10} sm={11} md={11}>
                  <div style={{ paddingLeft:0, marginLeft:-10, textAlign:"left" }}><span style={{fontFamily:"Helvetica", fontWeight:"300",  color:"#1A1A1A", marginTop:0}}>Διάβασα και αποδέχομαι τους <NavLink activeClassName="active" exact to={path_SettingsTermsBills}>Όρους & Προϋποθέσεις</NavLink> και ενημερώθηκα για την <NavLink activeClassName="active" exact to={path_SettingsPrivacy}>Πολιτική Προσωπικών Δεδομένων</NavLink></span></div>
                </GridItem>
              </GridContainer>
            )
            }
            <div style={{ marginTop:25 }}>
              <GridContainer justify="center">
                <GridItem xs={12} sm={12} md={12}>
                    <div className={classes.BillsPaymentReview_lbl_card12}>{this.NSInforString("BillsPaymentReview_lbl_card1")}{/* <img height="28" src={WU_Card_logos_visa} alt=""/><img height="30" src={WU_Card_logos_mastercard} alt=""/>*/}</div>
                </GridItem>
                {/* <GridItem xs={12} sm={12} md={12}>
                    <div className={classes.BillsPaymentReview_lbl_card12}>{this.NSInforString("BillsPaymentReview_lbl_card2")}</div>
                </GridItem> */}
              </GridContainer>
            </div>
            {/* ------------------------- */}
            {/* ----------[SPINNERS]----- */}
            {/* ------------------------- */}
            {this.state.viewPleaseWait_hidden === true ? ( "" ) : (
              <GridContainer justify="center">
                <GridItem xs={3} sm={3} md={3}></GridItem>
                <GridItem xs={6} sm={6} md={6}>
                  <div className={classes.pleaseWait}><CircularProgress/><span>&nbsp;{this.NSInforString("please_wait")}</span></div>
                </GridItem>
                <GridItem xs={3} sm={3} md={3}></GridItem>
              </GridContainer>
            )}
            {/* ------------------------- */}
            {/* ----------[BUTTONS]------ */}
            {/* ------------------------- */}
            {localStorage.getItem("payWithCardMethod")==="payWithCardMethod_Normal" ? (
              <GridContainer justify="center">
                <form id="cardPaymentFormNormal" action={api.url_onlinemt+api.webapp_path+"/bills/wbwu/redirect"} method="post">
                  {/* <GridItem xs={10} sm={10} md={10}> */}
                    {/* Peiraius Payment info */}
                    <input type="hidden" id="merchantReference"              name="merchantReference"              value={this.state.merchantReference}/>
                    <input type="hidden" id="user"                           name="user"                           value={this.state.user}/>
                    <input type="hidden" id="merchantId"                     name="merchantId"                     value={this.state.merchantId}/>
                    <input type="hidden" id="posId"                          name="posId"                          value={this.state.posId}/>
                    <input type="hidden" id="acquirerId"                     name="acquirerId"                     value={this.state.acquirerId}/>
                    <input type="hidden" id="LanguageCode"                   name="LanguageCode"                   value={this.state.LanguageCode}/>
                    {/* Session between domains : webapp & mobile */}
                    <input type="hidden" id="platform"                       name="platform"                       value="webapp-react"/>
                    <input type="hidden" id="accessToken"                    name="accessToken"                    value={localStorage.getItem("accessToken")}/>
                    {/* Session between domains : webapp */}
                    <input type="hidden" id="tokenID"                        name="tokenID"                        value={localStorage.getItem("tokenID")}/>
                    <input type="hidden" id="transId"                        name="transId"                        value={this.get_transId()}/>
                    <input type="hidden" id="billId"                         name="billId"                         value={this.get_billId()}/>
                    <input type="hidden" id="refreshToken"                   name="refreshToken"                   value={localStorage.getItem("refreshToken")}/>
                  {/* </GridItem> */}
                </form>
                <GridItem xs={10} sm={10} md={10}>
                  <div className={classes.textCenter}>
                    <CustomButton
                      disabled={this.btn_proceed_act_card_normal_isDisabled()}
                      className={classes.yellowButton}
                      color="rose"
                      onClick={this.btn_proceed_act_card_normal}
                      type="submit">
                      {this.NSInforString("BillsPaymentReview_btn_done")}
                    </CustomButton>
                  </div>
                </GridItem>
              </GridContainer>
            ) : ( "" )
            }

            {localStorage.getItem("payWithCardMethod")==="payWithCardMethod_Tokenized" ? (
              <GridContainer justify="center">
                <form id="cardPaymentFormTokenized" action={api.url_onlinemt+api.webapp_path+"/bills/bank/tokenized/redirect"} method="post">
                  {/* <GridItem xs={10} sm={10} md={10}> */}
                    {/* Peiraius Payment info */}
                    <input type="hidden" id="html"                           name="html"                           value={this.state.html}/>
                    <input type="hidden" id="LanguageCode"                   name="LanguageCode"                   value={this.state.LanguageCode}/>
                    {/* Session between domains : webapp & mobile */}
                    <input type="hidden" id="platform"                       name="platform"                       value="webapp-react"/>
                    <input type="hidden" id="accessToken"                    name="accessToken"                    value={localStorage.getItem("accessToken")}/>
                    {/* Session between domains : webapp */}
                    <input type="hidden" id="tokenID"                        name="tokenID"                        value={localStorage.getItem("tokenID")}/>
                    <input type="hidden" id="transId"                        name="transId"                        value={this.get_transId()}/>
                    <input type="hidden" id="billId"                         name="billId"                         value={this.get_billId()}/>
                    <input type="hidden" id="refreshToken"                   name="refreshToken"                   value={localStorage.getItem("refreshToken")}/>
                  {/* </GridItem> */}
                </form>
                <GridItem xs={10} sm={10} md={10}>
                  <div className={classes.textCenter}>
                    <CustomButton
                    disabled={this.btn_proceed_act_card_tokenized_isDisabled()}
                      className={classes.yellowButton}
                      color="rose"
                      onClick={this.btn_proceed_act_card_tokenized}
                      type="submit">
                      {this.NSInforString("BillsPaymentReview_btn_done")}
                    </CustomButton>
                  </div>
                </GridItem>
              </GridContainer>
            ) : ( "" )
            }

            {api.backButtonAtBottom === true ? (
              <GridContainer justify="center">
                <GridItem xs={10} sm={10} md={10}>
                  <div className={classes.textCenter}>
                    <CustomButton
                      disabled={false}
                      className={classes.backButton}
                      color="rose"
                      onClick={this.goBack}>
                      {this.NSInforString("BillsPaymentReview_btn_prev")}
                    </CustomButton>
                  </div>
                </GridItem>
              </GridContainer>
            ) : ( "" ) }

          </GridItem>
        </GridContainer>
        {/* ------------------------- */}
        {/* ----------[SNACKBAR]----- */}
        {/* ------------------------- */}
        <Snackbar open={this.state.Snackbar_textField_open} autoHideDuration={api.snackBarDurationMS} onClose={this.Snackbar_textField_handleClose}>
          <Alert onClose={this.Snackbar_textField_handleClose} severity="error">{this.state.Snackbar_textField_msg}</Alert>
        </Snackbar>
        {/* ---------------------------------------- */}
        {/* ----------[POPUP goBack]---------------- */}
        {/* ---------------------------------------- */}
        <div>
          <Dialog
            open={this.state.dialog_goBack_isOpen}
            TransitionComponent={Transition}
            keepMounted
            onClose={this.dialog_goBack_handleClose}
            aria-labelledby="alert-dialog-slide-title"
            aria-describedby="alert-dialog-slide-description"
          >
            <DialogTitle id="alert-dialog-slide-title">{api.popup_tile}</DialogTitle>
            <DialogContent>
              <GridItem xs={12} sm={12} md={12}><div className={classes.viewRN_key}>{this.state.dialog_goBack_msg}</div></GridItem>
              <GridItem xs={12} sm={12} md={12}></GridItem>
            </DialogContent>
            <DialogActions>
              <Button className={classes.popupOkButton} color="default" onClick={this.dialog_goBack_btn_OK}>OK</Button>
            </DialogActions>
          </Dialog>
        </div>
        {/* ---------------------------------------- */}
        {/* ----------[POPUP gotoController]-------- */}
        {/* ---------------------------------------- */}
        <div>
          <Dialog
            open={this.state.dialog_gotoController_isOpen}
            TransitionComponent={Transition}
            keepMounted
            onClose={this.dialog_gotoController_handleClose}
            aria-labelledby="alert-dialog-slide-title"
            aria-describedby="alert-dialog-slide-description"
          >
            <DialogTitle id="alert-dialog-slide-title">{api.popup_tile}</DialogTitle>
            <DialogContent>
              <GridItem xs={12} sm={12} md={12}><div className={classes.viewRN_key}>{this.state.dialog_gotoController_msg}</div></GridItem>
              <GridItem xs={12} sm={12} md={12}></GridItem>
            </DialogContent>
            <DialogActions>
              <Button className={classes.popupOkButton} color="default" onClick={this.dialog_gotoController_btn_OK}>OK</Button>
            </DialogActions>
          </Dialog>
        </div>
        {/* ------------------------- */}
        {/* ----------[POPUP]-------- */}
        {/* ------------------------- */}
        <div>
          <Dialog
            open={this.state.dialog_isOpen}
            TransitionComponent={Transition}
            keepMounted
            onClose={this.dialog_handleClose}
            aria-labelledby="alert-dialog-slide-title"
            aria-describedby="alert-dialog-slide-description"
          >
            <DialogTitle id="alert-dialog-slide-title">{api.popup_tile}</DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-slide-description">{this.state.dialog_msg}</DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button className={classes.popupOkButton} color="default" onClick={this.dialog_handleClose}>OK</Button>
            </DialogActions>
          </Dialog>
        </div>
        {/* ---------------------------- */}
        {/* ----------[DialogSpinner]--- */}
        {/* ---------------------------- */}
        <div>
          <Dialog
            open={this.state.dialog200_isOpen}
            TransitionComponent={Transition}
            keepMounted
            onClose={this.dialog200_handleClose}
            aria-labelledby="alert-dialog200-slide-title"
            aria-describedby="alert-dialog200-slide-description"
          >
            <DialogTitle id="alert-dialog-slide-title">{api.popup_tile}</DialogTitle>
            <DialogContent>
              <div className={classes.pleaseWaitPopup}><CircularProgress/><span>&nbsp;{this.state.dialog200_msg}</span></div>
            </DialogContent>
          </Dialog>
        </div>
      </div>
    );
  }
  //-------------------------------------------------------------------------------------------------------------------------------
  makeScreenTranslations(){
      let methName = filename+"makeScreenTranslations ";
      if(api.print_logs){console.log(methName);}

      var parserObject_categoriesCompaniesList = null;
      try{ parserObject_categoriesCompaniesList = (JSON.parse(localStorage.getItem("categoriescompanies"))).billers ;}catch(err){console.log(methName+'err='+err);}

      var ws_billId = 0;
      try{ ws_billId = parseInt(localStorage.getItem("bills_billerId"));}catch(err){console.log(methName+'err='+err);}

      var imageURL = api.url + wu_Utilities.bills_images_urls(ws_billId,parserObject_categoriesCompaniesList);
      if(api.print_logs){console.log(methName+"imageURL="+imageURL);}

      //D2B Fields
      let lbl_billsKeyVal01_isHidden=true; let lbl_billsKey01 = ""; let lbl_billsVal01 = "";
      let lbl_billsKeyVal02_isHidden=true; let lbl_billsKey02 = ""; let lbl_billsVal02 = "";
      let lbl_billsKeyVal03_isHidden=true; let lbl_billsKey03 = ""; let lbl_billsVal03 = "";
      let lbl_billsKeyVal04_isHidden=true; let lbl_billsKey04 = ""; let lbl_billsVal04 = "";
      let lbl_billsKeyVal05_isHidden=true; let lbl_billsKey05 = ""; let lbl_billsVal05 = "";
      let lbl_billsKeyVal06_isHidden=true; let lbl_billsKey06 = ""; let lbl_billsVal06 = "";
      let lbl_billsKeyVal07_isHidden=true; let lbl_billsKey07 = ""; let lbl_billsVal07 = "";
      let lbl_billsKeyVal08_isHidden=true; let lbl_billsKey08 = ""; let lbl_billsVal08 = "";
      let lbl_billsKeyVal09_isHidden=true; let lbl_billsKey09 = ""; let lbl_billsVal09 = "";

      let parserObject_bills_payment_info_generic_aux = {};
      try { parserObject_bills_payment_info_generic_aux = JSON.parse(localStorage.getItem("parserObject_bills_payment_info_generic_aux")); }catch(err){;}
      for(let i=0; i<parserObject_bills_payment_info_generic_aux.length; ++i){
          let clientType = "";
          let fieldName  = "";
          let value      = "";
          try {clientType = parserObject_bills_payment_info_generic_aux[i]["clientType"];}catch(err){ ; }
          try {fieldName  = parserObject_bills_payment_info_generic_aux[i]["name"];}catch(err){ ; }
          try {value      = parserObject_bills_payment_info_generic_aux[i]["value"];    }catch(err){ ; }
          if(i===0){lbl_billsKeyVal01_isHidden=false; lbl_billsKey01 = fieldName; if(clientType==="DOUBLE"){value=wu_Utilities.bills_amount_with_comma(wu_Utilities.bills_normalizeAmount(value)) + " EUR";} lbl_billsVal01 = value;}
          if(i===1){lbl_billsKeyVal02_isHidden=false; lbl_billsKey02 = fieldName; if(clientType==="DOUBLE"){value=wu_Utilities.bills_amount_with_comma(wu_Utilities.bills_normalizeAmount(value)) + " EUR";} lbl_billsVal02 = value;}
          if(i===2){lbl_billsKeyVal03_isHidden=false; lbl_billsKey03 = fieldName; if(clientType==="DOUBLE"){value=wu_Utilities.bills_amount_with_comma(wu_Utilities.bills_normalizeAmount(value)) + " EUR";} lbl_billsVal03 = value;}
          if(i===3){lbl_billsKeyVal04_isHidden=false; lbl_billsKey04 = fieldName; if(clientType==="DOUBLE"){value=wu_Utilities.bills_amount_with_comma(wu_Utilities.bills_normalizeAmount(value)) + " EUR";} lbl_billsVal04 = value;}
          if(i===4){lbl_billsKeyVal05_isHidden=false; lbl_billsKey05 = fieldName; if(clientType==="DOUBLE"){value=wu_Utilities.bills_amount_with_comma(wu_Utilities.bills_normalizeAmount(value)) + " EUR";} lbl_billsVal05 = value;}
          if(i===5){lbl_billsKeyVal06_isHidden=false; lbl_billsKey06 = fieldName; if(clientType==="DOUBLE"){value=wu_Utilities.bills_amount_with_comma(wu_Utilities.bills_normalizeAmount(value)) + " EUR";} lbl_billsVal06 = value;}
          if(i===6){lbl_billsKeyVal07_isHidden=false; lbl_billsKey07 = fieldName; if(clientType==="DOUBLE"){value=wu_Utilities.bills_amount_with_comma(wu_Utilities.bills_normalizeAmount(value)) + " EUR";} lbl_billsVal07 = value;}
          if(i===7){lbl_billsKeyVal08_isHidden=false; lbl_billsKey08 = fieldName; if(clientType==="DOUBLE"){value=wu_Utilities.bills_amount_with_comma(wu_Utilities.bills_normalizeAmount(value)) + " EUR";} lbl_billsVal08 = value;}
          if(i===8){lbl_billsKeyVal09_isHidden=false; lbl_billsKey09 = fieldName; if(clientType==="DOUBLE"){value=wu_Utilities.bills_amount_with_comma(wu_Utilities.bills_normalizeAmount(value)) + " EUR";} lbl_billsVal09 = value;}
      }

      this.setState({
        "lbl_status"                 : wu_Utilities.bills_companyNameFromBillId(ws_billId, parserObject_categoriesCompaniesList),
        "lbl_date"                   : "",
        "imv_logo"                   : imageURL,

        "lbl_billsKeyVal01_isHidden" : lbl_billsKeyVal01_isHidden,
        "lbl_billsKeyVal02_isHidden" : lbl_billsKeyVal02_isHidden,
        "lbl_billsKeyVal03_isHidden" : lbl_billsKeyVal03_isHidden,
        "lbl_billsKeyVal04_isHidden" : lbl_billsKeyVal04_isHidden,
        "lbl_billsKeyVal05_isHidden" : lbl_billsKeyVal05_isHidden,
        "lbl_billsKeyVal06_isHidden" : lbl_billsKeyVal06_isHidden,
        "lbl_billsKeyVal07_isHidden" : lbl_billsKeyVal07_isHidden,
        "lbl_billsKeyVal08_isHidden" : lbl_billsKeyVal08_isHidden,
        "lbl_billsKeyVal09_isHidden" : lbl_billsKeyVal09_isHidden,

        "lbl_billsKey01"             : lbl_billsKey01,
        "lbl_billsKey02"             : lbl_billsKey02,
        "lbl_billsKey03"             : lbl_billsKey03,
        "lbl_billsKey04"             : lbl_billsKey04,
        "lbl_billsKey05"             : lbl_billsKey05,
        "lbl_billsKey06"             : lbl_billsKey06,
        "lbl_billsKey07"             : lbl_billsKey07,
        "lbl_billsKey08"             : lbl_billsKey08,
        "lbl_billsKey09"             : lbl_billsKey09,

        "lbl_billsVal01"             : lbl_billsVal01,
        "lbl_billsVal02"             : lbl_billsVal02,
        "lbl_billsVal03"             : lbl_billsVal03,
        "lbl_billsVal04"             : lbl_billsVal04,
        "lbl_billsVal05"             : lbl_billsVal05,
        "lbl_billsVal06"             : lbl_billsVal06,
        "lbl_billsVal07"             : lbl_billsVal07,
        "lbl_billsVal08"             : lbl_billsVal08,
        "lbl_billsVal09"             : lbl_billsVal09,
      });

      if(Cookies.get('wuwb4c_cardPaymentStatus')==="failure" && Cookies.get('wuwb4c_customerCancelled')!=="true" ){
        var ResultCode_int = 0;
        var ResultCode_str = "";
        try{ ResultCode_int = parseInt(Cookies.get('wuwb4c_ResultCode')); }catch(err){;}
        try{ ResultCode_str = Cookies.get('wuwb4c_ResultCode'); }catch(err){;}
        if([6001, 500, 501, 1040, 1041, 1072, 7001].includes(ResultCode_int) || ResultCode_str.startsWith("50")){ this.dialog_handleOpen(               this.NSInforString("BillsPaymentReview_lbl_card_error_1")); } //===>BillsPaymentReview(STAY in the same screen)
        else if([6002, 1048, 1045].includes(ResultCode_int))                                                    { this.dialog_gotoController_handleOpen(this.NSInforString("BillsPaymentReview_lbl_card_error_2")); } //===>Bills
        else if([6003].includes(ResultCode_int))                                                                { this.dialog_goBack_handleOpen(        this.NSInforString("BillsPaymentReview_lbl_card_error_3")); }//===>BillsPaymentSetup
        else if([6004, 100, 130, 151, 215, 216, 981, 1802].includes(ResultCode_int))                            { this.dialog_handleOpen(               this.NSInforString("BillsPaymentReview_lbl_card_error_4")); }//===>BillsPaymentReview(STAY in the same screen)
        else                                                                                                    { this.dialog_handleOpen(               this.NSInforString("BillsPaymentReview_lbl_card_error"));   } //===>BillsPaymentReview(STAY in the same screen)
        Cookies.set('wuwb4c_cardPaymentStatus',"");
      }
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Drop Down Listeners-------------------------------
  //----------------------------------------------------------------------------------------------------

  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------CheckBox Listeners--------------------------------
  //----------------------------------------------------------------------------------------------------
  handleCheckBoxClick_userAcceptedTerms(event) {
    let methName = filename+"handleCheckBoxClick_userAcceptedTerms ";
    if(api.print_logs){console.log(methName+event.target.checked);}
    this.setState({ "userAcceptedTerms":event.target.checked });
  }
  //----------------------------------------------------------------------------------------------------
  handleCheckBoxClick_saveNewCard(event) {
    let methName = filename+"handleCheckBoxClick_saveNewCard ";
    if(api.print_logs){console.log(methName+event.target.checked);}
    this.setState({ "ShouldSaveCard":event.target.checked });
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------RadioButton Listeners-----------------------------
  //----------------------------------------------------------------------------------------------------
  //...
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Button Listeners----------------------------------
  //----------------------------------------------------------------------------------------------------
  btn_proceed_act_card_normal_isDisabled(){

    if(this.isLockersActive()===true){ return true; }
    return false;
  }
  //----------------------------------------------------------------------------------------------------
  btn_proceed_act_card_normal(event) {
    let methName = filename+"btn_proceed_act_card_normal ";
    if(api.print_logs){console.log(methName);}

    //[Lockers]
    if( this.isLockersActive() ){ return; }
    else                        { this.startLockers(); }

    //++++++++++++++++++++++
    //webapp session timeout
    //++++++++++++++++++++++
    if(wu_Utilities.checkIfUserIsLoggedIn()){
      wu_Utilities.update_uilatstats();
      if(!wu_Utilities.check_uilatstats(api.uilatstats_inactivity_mins)){ wu_Utilities.LogoutUserFromApp(filename); history.push(wu_Utilities.getNavigationURLs("LoginPage")); return; }
    }
    //+++++++++++++++++++++++
    //validate Only Emptyness
    //+++++++++++++++++++++++
    let validateOnlyEmptyness = true;
    if(validateOnlyEmptyness){
      let emptyFields = false;
      if(emptyFields===true){this.stopLockers();return;}
    }
    //-----------------------
    //validate cardHolderName
    //-----------------------
    let textField1text = this.state.textField1.trim();
    if(textField1text === ""){ //VLDT:empty
        this.dialog_handleOpen(this.NSInforString("emtpy_field")+"\""+this.NSInforString("BillsPaymentReview_plh1")+"\"");
        this.setState({"textField1_hasError" : true });
        this.stopLockers();return;
    }
    if(wu_Utilities.offline_validate_latinCharacters(textField1text.replace(/ /g,"").replace(/\./g,""))===false){
        this.dialog_handleOpen(this.NSInforString("emtpy_field")+"\""+this.NSInforString("BillsPaymentReview_plh1")+"\" "+this.NSInforString("with_latin"));
        this.setState({"textField1_hasError" : true });
        this.stopLockers();return;
    }
    if(textField1text.length < 2 || textField1text.length > 26 ){
        this.dialog_handleOpen(this.NSInforString("common.cardHolderName.size"));
        this.setState({"textField1_hasError" : true });
        this.stopLockers();return;
    }
    //--------------
    //validate Terms---CheckBox
    //--------------
    if(this.state.userAcceptedTerms===false){
        this.dialog_handleOpen(this.NSInforString("BillsPaymentReview_msg_terms"));
        this.stopLockers();return;
    }

    this.makeHTTPConn_proceed_card_normal();
  }
  //----------------------------------------------------------------------------------------------------
  makeHTTPConn_proceed_card_normal(){
    let methName = filename+"makeHTTPConn_proceed_card_normal ";
    if(api.print_logs){console.log(methName);}

    var ws_billId = 0;
    try{ ws_billId = parseInt(localStorage.getItem("bills_billerId"));}catch(err){console.log(methName+'err='+err);}

    //--------------------
    //wu_bills_payment_pay
    //--------------------
    let amount   = wu_Utilities.bills_getPaymentAmount();      if(api.print_logs){console.log(methName+"amount   = " + amount);}
    let fees     = wu_Utilities.bills_getPaymentFees();        if(api.print_logs){console.log(methName+"fees     = " + fees);}
    let gross_f1 = amount + fees;                              if(api.print_logs){console.log(methName+"gross_f1 = " + gross_f1);}
  //let gross_f2 = parseFloat(Math.floor(100 * gross_f1)/100); if(api.print_logs){console.log(methName+"gross_f2 = " + gross_f2);}
    let gross_f2 = parseFloat(100 * gross_f1/100);             if(api.print_logs){console.log(methName+"gross_f2 = " + gross_f2);}
    var parserObject_bills_payment_pay_req = {};
    parserObject_bills_payment_pay_req["billerID"]       = ws_billId;
    parserObject_bills_payment_pay_req["charges"]        = String(fees);
    parserObject_bills_payment_pay_req["gross"]          = String(gross_f2.toFixed(2));
    parserObject_bills_payment_pay_req["cardHolderName"] = this.state.textField1.trim();

    var parserObject_bills_payment_info_generic_aux = null;
    try{ parserObject_bills_payment_info_generic_aux = JSON.parse(localStorage.getItem("parserObject_bills_payment_info_generic_aux"));}catch(err){console.log(methName+'err='+err);}
    let fieldValues = [];
    for(let i=0; i<parserObject_bills_payment_info_generic_aux.length; ++i){
        let item = parserObject_bills_payment_info_generic_aux[i];
        var ws_type  = "";
        var ws_value = "";
        var ws_id    = 0;
        try{ ws_type  = item["type"];  }catch (err){ ws_type  = ""; }
        try{ ws_value = item["value"]; }catch (err){ ws_value = ""; }
        try{ ws_id    = item["id"];    }catch (err){ ws_id    = 0;  }
        let item_new = {};
        item_new["fieldValue"] = ws_value;
        item_new["fieldId"]    = ws_id;
        if((ws_type === "FEES") === false){
            fieldValues.push(item_new);
        }
    }
    parserObject_bills_payment_pay_req["fieldValues"] = fieldValues;
    parserObject_bills_payment_pay_req["saveCard"]    = (this.state.ShouldSaveCard === true) ? 1 : 0;

    if(this.state.dialog200_isOpen===false){this.dialog200_handleOpen(this.NSInforString("BillsPaymentReview_lbl_card2"));}
    wu_BillsService
    .wu_bills_payment_pay(parserObject_bills_payment_pay_req)
    .then(res => {
      if(localStorage.getItem("curr_view").trim()!=="BillsPaymentReview"){if(api.print_logs){console.log(methName+"5A11");}return;}//5A11
      localStorage.setItem("bills_billsHistoryDetail_FLOW", "bills_billsHistoryDetail_FLOW_PAYMENT");
      localStorage.setItem("bills_payWithCardMethod",       "bills_payWithCardMethod_Normal");
      try{     Cookies.set('bills_billsHistoryDetail_FLOW', "bills_billsHistoryDetail_FLOW_PAYMENT", {secure:true,expires:1,path:api.webapp_path}); }catch(err){console.log(methName+"err="+err);}
      try{     Cookies.set('bills_payWithCardMethod',       "bills_payWithCardMethod_Normal",        {secure:true,expires:1,path:api.webapp_path}); }catch(err){console.log(methName+"err="+err);}
      localStorage.setItem("bills_tokenizedPaymentMethod", "");
      try{     Cookies.set('bills_tokenizedPaymentMethod', "",                                       {secure:true,expires:1,path:api.webapp_path}); }catch(err){console.log(methName+"err="+err);}
      /*this.stopLockers(); creates problem with double click thats why*/this.stopSpinners();this.dialog200_handleClose();//stop DialogSpinner = YES
      localStorage.setItem("parserObject_bills_payment_pay_res",JSON.stringify(res));
      localStorage.setItem("transId", "");
      this.load_localStorage_to_cookies();
      let merchantReference = "";
      let user              = "";
      let merchantId        = "";
      let posId             = "";
      let acquirerId        = "";
      let LanguageCode      = "";
      let parserObject_bills_payment_pay_res = null;
      try{ parserObject_bills_payment_pay_res = JSON.parse(localStorage.getItem("parserObject_bills_payment_pay_res"));} catch(err){;}
      try{ merchantReference = parserObject_bills_payment_pay_res["merchantReference"]; }catch(err){merchantReference = "";}
      try{ user              = parserObject_bills_payment_pay_res["user"];              }catch(err){user              = "";}
      try{ merchantId        = parserObject_bills_payment_pay_res["merchantId"];        }catch(err){merchantId        = "";}
      try{ posId             = parserObject_bills_payment_pay_res["posId"];             }catch(err){posId             = "";}
      try{ acquirerId        = parserObject_bills_payment_pay_res["acquirerId"];        }catch(err){acquirerId        = "";}
      LanguageCode           = localStorage.getItem("lang")==="en" ? "en-US" : "el-GR";
      this.setState({
        merchantReference                                    : merchantReference,
        user                                                 : user,
        merchantId                                           : merchantId,
        posId                                                : posId,
        acquirerId                                           : acquirerId,
        LanguageCode                                         : LanguageCode,
      });
      setTimeout(function() { //Start the timer
        if (typeof document.getElementById('cardPaymentFormNormal').submit === "object") {
            document.getElementById('cardPaymentFormNormal').submit.remove();
        }
        document.getElementById('cardPaymentFormNormal').submit();
    //}.bind(this), 500);
      }.bind(), 500);
    })
    .catch(err => {
      this.stopLockers();this.stopSpinners();this.dialog200_handleClose();//stop DialogSpinner = YES
      console.log(methName+"err="+JSON.stringify(err));
      if(err && err.returnCode && err.returnCode!==0){ if(err.returnCode===100){console.log("!!!!!!!!!!Logout("+filename+"-01)!!!!!!!!!!");wu_Utilities.LogoutUserFromApp(filename);history.push(wu_Utilities.getNavigationURLs("LoginPage"));} this.dialog_handleOpen(err.returnText,"NET"); }
      else                                           { this.dialog_handleOpen(this.NSInforString("networkerror"),"NET"); }
    });
  }
  //----------------------------------------------------------------------------------------------------
  //----------------------------------------------------------------------------------------------------
  btn_proceed_act_card_tokenized_isDisabled(){

    if(this.isLockersActive()===true){ return true; }
    return false;
  }
  //----------------------------------------------------------------------------------------------------
  btn_proceed_act_card_tokenized(event) {
    let methName = filename+"btn_proceed_act_card_tokenized ";
    if(api.print_logs){console.log(methName);}

    //[Lockers]
    if( this.isLockersActive() ){ return; }
    else                        { this.startLockers(); }

    //++++++++++++++++++++++
    //webapp session timeout
    //++++++++++++++++++++++
    if(wu_Utilities.checkIfUserIsLoggedIn()){
      wu_Utilities.update_uilatstats();
      if(!wu_Utilities.check_uilatstats(api.uilatstats_inactivity_mins)){ wu_Utilities.LogoutUserFromApp(filename); history.push(wu_Utilities.getNavigationURLs("LoginPage")); return; }
    }
    //+++++++++++++++++++++++
    //validate Only Emptyness
    //+++++++++++++++++++++++
    let validateOnlyEmptyness = true;
    if(validateOnlyEmptyness){
      let emptyFields = false;
      if(emptyFields===true){this.stopLockers();return;}
    }
    //--------------
    //validate Terms---CheckBox
    //--------------
    if(this.state.userAcceptedTerms===false){
        this.dialog_handleOpen(this.NSInforString("BillsPaymentReview_msg_terms"));
        this.stopLockers();return;
    }

    this.makeHTTPConn_proceed_card_tokenized();
  }
  //----------------------------------------------------------------------------------------------------
  makeHTTPConn_proceed_card_tokenized(){
    let methName = filename+"makeHTTPConn_proceed_card_tokenized ";
    if(api.print_logs){console.log(methName);}

    var ws_billId = 0;
    try{ ws_billId = parseInt(localStorage.getItem("bills_billerId"));}catch(err){console.log(methName+'err='+err);}

    //-------------------
    //wu_cardpaymentpayBP
    //-------------------
    let amount   = wu_Utilities.bills_getPaymentAmount();      if(api.print_logs){console.log(methName+"amount   = " + amount);}
    let fees     = wu_Utilities.bills_getPaymentFees();        if(api.print_logs){console.log(methName+"fees     = " + fees);}
    let gross_f1 = amount + fees;                              if(api.print_logs){console.log(methName+"gross_f1 = " + gross_f1);}
  //let gross_f2 = parseFloat(Math.floor(100 * gross_f1)/100); if(api.print_logs){console.log(methName+"gross_f2 = " + gross_f2);}
    let gross_f2 = parseFloat(100 * gross_f1/100);             if(api.print_logs){console.log(methName+"gross_f2 = " + gross_f2);}
    var parserObject_bills_payment_payBP_req = {};
    parserObject_bills_payment_payBP_req["billerID"]       = ws_billId;
    parserObject_bills_payment_payBP_req["charges"]        = String(fees);
    parserObject_bills_payment_payBP_req["gross"]          = String(gross_f2.toFixed(2));

    var parserObject_bills_payment_info_generic_aux = null;
    try{ parserObject_bills_payment_info_generic_aux = JSON.parse(localStorage.getItem("parserObject_bills_payment_info_generic_aux"));}catch(err){console.log(methName+'err='+err);}
    let fieldValues = [];
    for(let i=0; i<parserObject_bills_payment_info_generic_aux.length; ++i){
        let item = parserObject_bills_payment_info_generic_aux[i];
        var ws_type  = "";
        var ws_value = "";
        var ws_id    = 0;
        try{ ws_type  = item["type"];  }catch (err){ ws_type  = ""; }
        try{ ws_value = item["value"]; }catch (err){ ws_value = ""; }
        try{ ws_id    = item["id"];    }catch (err){ ws_id    = 0;  }
        let item_new = {};
        item_new["fieldValue"] = ws_value;
        item_new["fieldId"]    = ws_id;
        if((ws_type === "FEES") === false){
            fieldValues.push(item_new);
        }
    }
    parserObject_bills_payment_payBP_req["fieldValues"] = fieldValues;

    var token = "";
    let parserObject_selectedTokenizedCard = {};
    try { parserObject_selectedTokenizedCard = JSON.parse(localStorage.getItem("parserObject_selectedTokenizedCard")); }catch(err){;}
    try { token = parserObject_selectedTokenizedCard["token"]; }catch(err){;} if(token === null || (typeof token ==="undefined")){token = "";}
    parserObject_bills_payment_payBP_req["token"] = token;

    //screenWidth,screenHeight,timezone
    parserObject_bills_payment_payBP_req["screenWidth"]  = String(window.innerWidth);
    parserObject_bills_payment_payBP_req["screenHeight"] = String(window.innerHeight);
    parserObject_bills_payment_payBP_req["timezone"]     = String((new Date()).getTimezoneOffset());

    let wu_cardpaymentpayBP_START=new Date(); if(this.state.dialog200_isOpen===false){this.dialog200_handleOpen(this.NSInforString("BillsPaymentReview_lbl_card2"));}
    wu_TransactionFlow
    .wu_cardpaymentpayBP(parserObject_bills_payment_payBP_req)
    .then(res => {
      if(localStorage.getItem("curr_view").trim()!=="BillsPaymentReview"){if(api.print_logs){console.log(methName+"5A11");}return;}//5A11
      localStorage.setItem("bills_billsHistoryDetail_FLOW", "bills_billsHistoryDetail_FLOW_PAYMENT");
      localStorage.setItem("bills_payWithCardMethod",       "bills_payWithCardMethod_Tokenized");
      try{     Cookies.set('bills_billsHistoryDetail_FLOW', "bills_billsHistoryDetail_FLOW_PAYMENT", {secure:true,expires:1,path:api.webapp_path}); }catch(err){console.log(methName+"err="+err);}
      try{     Cookies.set('bills_payWithCardMethod',       "bills_payWithCardMethod_Tokenized",     {secure:true,expires:1,path:api.webapp_path}); }catch(err){console.log(methName+"err="+err);}
      /*this.stopLockers(); creates problem with double click thats why*/this.stopSpinners();this.dialog200_handleClose();//stop DialogSpinner = YES
      localStorage.setItem("parserObject_cardpaymentpayBP_res",JSON.stringify(res));
      localStorage.setItem("transId", "");
      this.load_localStorage_to_cookies();
      let renderContent     = "";
      let LanguageCode      = "";
      var transId           = "";
      let parserObject_cardpaymentpayBP_res = null;
      try{ parserObject_cardpaymentpayBP_res = JSON.parse(localStorage.getItem("parserObject_cardpaymentpayBP_res"));} catch(err){;}
      try{ renderContent     = parserObject_cardpaymentpayBP_res["renderContent"]; }catch(err){renderContent = "";}
      try{ transId           = parserObject_cardpaymentpayBP_res["transId"];       }catch(err){transId       = "";}
      LanguageCode           = localStorage.getItem("lang")==="en" ? "en-US" : "el-GR";
      if(renderContent==="" || (typeof renderContent ==="undefined") || renderContent===null){
        localStorage.setItem("bills_tokenizedPaymentMethod",  "bills_tokenizedPaymentMethod_without3DS");
        try{     Cookies.set('bills_tokenizedPaymentMethod',  "bills_tokenizedPaymentMethod_without3DS", {secure:true,expires:1,path:api.webapp_path}); }catch(err){console.log(methName+"err="+err);}
        if(api.print_logs){console.log(methName+"transId="+transId);}
        if(transId!=="" && (typeof transId!=="undefined") && transId!==null){
          localStorage.setItem("transId", transId);
        }
        //+++++++++++++++
        //Goto Controller
        //+++++++++++++++
        history.push(wu_Utilities.getNavigationURLs("BillsHistoryDetail"));
      }
      else{
        localStorage.setItem("bills_tokenizedPaymentMethod", "bills_tokenizedPaymentMethod_with3DS");
        try{     Cookies.set('bills_tokenizedPaymentMethod', "bills_tokenizedPaymentMethod_with3DS", {secure:true,expires:1,path:api.webapp_path}); }catch(err){console.log(methName+"err="+err);}
        this.setState({
          html                                                 : new Buffer(renderContent).toString('base64'),
          LanguageCode                                         : LanguageCode,
        });
        setTimeout(function() { //Start the timer
          if (typeof document.getElementById('cardPaymentFormTokenized').submit === "object") {
              document.getElementById('cardPaymentFormTokenized').submit.remove();
          }
          document.getElementById('cardPaymentFormTokenized').submit();
        }.bind(this), 500);
      }
    })
    .catch(err => {
      let wu_cardpaymentpayBP_dur=wu_Utilities.diffDatesSec(wu_cardpaymentpayBP_START);console.log(methName+"wu_cardpaymentpayBP_dur="+wu_cardpaymentpayBP_dur);
      this.stopLockers();this.stopSpinners();this.dialog200_handleClose();//stop DialogSpinner = YES
      console.log(methName+"err="+JSON.stringify(err));
           if(err && err.returnCode && err.returnCode===100) { console.log("!!!!!!!!!!Logout("+filename+"-01)!!!!!!!!!!");wu_Utilities.LogoutUserFromApp(filename);history.push(wu_Utilities.getNavigationURLs("LoginPage")); }
      else if(err && err.returnCode && err.returnCode===6001){ this.dialog_handleOpen(               this.NSInforString("BillsPaymentReview_lbl_card_error_1")); } //===>BillsPaymentReview(STAY in the same screen)
      else if(err && err.returnCode && err.returnCode===6002){ this.dialog_gotoController_handleOpen(this.NSInforString("BillsPaymentReview_lbl_card_error_2")); } //===>Bills
      else if(err && err.returnCode && err.returnCode===6003){ this.dialog_goBack_handleOpen(        this.NSInforString("BillsPaymentReview_lbl_card_error_3")); } //===>BillsPaymentSetup
      else if(err && err.returnCode && err.returnCode===6004){ this.dialog_handleOpen(               this.NSInforString("BillsPaymentReview_lbl_card_error_4")); } //===>BillsPaymentReview(STAY in the same screen)
      else if(err && err.returnCode && err.returnCode!==0)   { this.dialog_handleOpen(err.returnText,"NET"); }
      else if(wu_cardpaymentpayBP_dur>=59)                   { this.dialog_gotoController_handleOpen(this.NSInforString("BillsPaymentReview_msg_60sec"),"NET"); }
      else                                                   { this.dialog_handleOpen(this.NSInforString("networkerror"),"NET"); }
    });
  }
  //----------------------------------------------------------------------------------------------------
  //----------------------------------------------------------------------------------------------------
  //----------------------------------------------------------------------------------------------------
  get_transId(){
    let methName = filename+"get_transId ";
    if(api.print_logs){console.log(methName);}

    if(localStorage.getItem("payWithCardMethod")==="payWithCardMethod_Tokenized"){
      try {
        let transId = "";
        let parserObject_cardpaymentpayBP_res = JSON.parse(localStorage.getItem("parserObject_cardpaymentpayBP_res"));
        transId = parserObject_cardpaymentpayBP_res["transId"]; if(transId===null){transId = "";}
        if(transId === null || (typeof transId ==="undefined")){ return ""; }
        return transId;
      }catch(err0){console.log(methName+"err0="+err0);}
    }
    else{
      try {
        let transId = "";
        let parserObject_bills_payment_pay_res = JSON.parse(localStorage.getItem("parserObject_bills_payment_pay_res"));
        transId = parserObject_bills_payment_pay_res["transId"]; if(transId===null){transId = "";}
        if(transId === null || (typeof transId ==="undefined")){ return ""; }
        return transId;
      }catch(err0){console.log(methName+"err0="+err0);}
    }

    return "";
  }
  //----------------------------------------------------------------------------------------------------
  get_billId(){
    let methName = filename+"get_billId ";
    if(api.print_logs){console.log(methName);}

    var ws_billId = 0;
    try{ ws_billId = parseInt(localStorage.getItem("bills_billerId"));}catch(err){console.log(methName+'err='+err);}

    return ws_billId;
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------TextField Listeners-------------------------------
  //----------------------------------------------------------------------------------------------------
  change(event, stateVar) {
    let eventTMP = event.target.value+"";
    if(api.print_logs){console.log(stateVar+" "+event.target.value);}

    // if(api.allow_hp_to_be_edited===true && stateVar==="textField0"){ //[HONEYMOON]
    //   this.setState({"textField0":eventTMP.trim(),});
    // }
    if(stateVar==="textField1"){
      eventTMP = eventTMP.toUpperCase();
      this.setState({
        "textField1"          : eventTMP,
        "textField1_hasError" : (eventTMP.trim() === "") ? true : false,
      });
      if(eventTMP.length>0 && wu_Utilities.offline_validate_latinCharacters(eventTMP.replace(/ /g,"").replace(/\./g,""))===false){ this.Snackbar_textField_handleOpen(this.NSInforString("common.field.latin")); this.setState({"textField1_hasError":true}); return; }
    //if(eventTMP.trim().length > 26 || eventTMP.trim().length < 2){ this.Snackbar_textField_handleOpen(this.NSInforString("common.cardHolderName.size")); this.setState({"textField1_hasError":true}); return; }
      if(eventTMP.trim().length > 26){ this.Snackbar_textField_handleOpen(this.NSInforString("common.cardHolderName.size")); this.setState({"textField1_hasError":true}); return; }
      else                           { this.setState({"textField1_hasError":false}); }
    }
    else{
      this.setState({ [stateVar] : event.target.value });
    }
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Utilities-----------------------------------------
  //----------------------------------------------------------------------------------------------------
  NSInforString = aKey => {
    if(localStorage.getItem("lang")==="en"){ return this.texts_en[aKey] ? this.texts_en[aKey] : ""; }
    else                                   { return this.texts_gr[aKey] ? this.texts_gr[aKey] : ""; }
  };
  //----------------------------------------------------------------------------------------------------
  NSInforString_withLang(aKey,lang){
    if(lang==="en"){ return this.texts_en[aKey] ? this.texts_en[aKey] : ""; }
    else           { return this.texts_gr[aKey] ? this.texts_gr[aKey] : ""; }
  };
  //----------------------------------------------------------------------------------------------------
  verifyLength(value, length) {
    if (value && value.length >= length) { return true; }
    return false;
  }
  //----------------------------------------------------------------------------------------------------
  verifyGenericItem(key,val) {
    if(key==="email"){ return wu_Utilities.wu_verifyEmail(val); }
    if(key==="MTCN") { return wu_Utilities.wu_verifyMTCN(val);  }

    return false;
  }
  importAll(r) {
    //return r.keys().map(r);
    let images = {};
    r.keys().map((item, index) => {
      images[item.replace('./', '')] = r(item);
      return "";
    });
    return images;
  }
  //----------------------------------------------------------------------------------------------------
  comvert2ProperAmountFormat(amountStr){
    try{
      let parts = amountStr.split('.');
      let part1 = this.numberWithCommas(parts[0]);
      let part2 = parts[1];
      return part1+","+part2;
    }catch(err){;}
    return amountStr;
  }
  numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  }
  //----------------------------------------------------------------------------------------------------
  process_CategoriesCompaniesObject(){
    let methName = filename+"process_CategoriesCompaniesObject ";
    if(api.print_logs){console.log(methName);}

    let categoryFieldDescr = localStorage.getItem("lang")==="el" ? "categoryEl" : "categoryEn";
    var parserObject_categoriesList = [];
    var parserObject_categoriesCompaniesList = null;
    try{ parserObject_categoriesCompaniesList = (JSON.parse(localStorage.getItem("categoriescompanies"))).billers ;}catch(err){console.log(methName+'err='+err);}

    for(var i=0; i<parserObject_categoriesCompaniesList.length; ++i){
       let aItem = parserObject_categoriesCompaniesList[i];
       let category   = "";
       var categoryEl = "";
       var categoryEn = "";
       var mid        = 0;
       try {category   = aItem[categoryFieldDescr]; }catch(err){;} if(category   === null || (typeof category   ==="undefined")){category   = "";}
       try {categoryEl = aItem["categoryEl"];       }catch(err){;} if(categoryEl === null || (typeof categoryEl ==="undefined")){categoryEl = "";}
       try {categoryEn = aItem["categoryEn"];       }catch(err){;} if(categoryEn === null || (typeof categoryEn ==="undefined")){categoryEn = "";}
       try {mid        = aItem["mid"];              }catch(err){;} if(mid        === null || (typeof mid        ==="undefined")){mid        = 0;}
       if(api.bills_exclude_flags_enabled===true && wu_Utilities.bills_shouldBeInCategoriesListing(aItem)===false){continue;}
       if(wu_Utilities.bills_categoryExists(category, parserObject_categoriesList) === false){
           let aCategory = {};
           aCategory["category"]   = category;
           aCategory["categoryEl"] = categoryEl;
           aCategory["categoryEn"] = categoryEn;
           aCategory["mid"]        = mid;
           parserObject_categoriesList.push(aCategory);
       }
    }

    parserObject_categoriesList.sort(function(a, b) {
      if( (a.category).localeCompare(b.category) === -1){ return -1; }
      if( (a.category).localeCompare(b.category) === 1){ return 1; }
      return 0;
    });

    var popularFound = false;
    for(var j=0; j<parserObject_categoriesCompaniesList.length; ++j){
       let aItem = parserObject_categoriesCompaniesList[j];
       if(api.bills_exclude_flags_enabled===true && wu_Utilities.bills_shouldBeInCategoriesListing(aItem)===false){continue;}
       var popularity = 0;
       try {popularity = aItem["popularity"]; }catch(err){;} if(popularity === null || (typeof popularity ==="undefined")){popularity = 0;}
       let category = this.NSInforString("Bills_popular_category");
       if(popularity > 0 && popularFound === false){
           let aCategory = {};
           aCategory["category"]   = category;
           aCategory["categoryEl"] = this.NSInforString_withLang("Bills_popular_category","el");
           aCategory["categoryEn"] = this.NSInforString_withLang("Bills_popular_category","en");
           aCategory["mid"]        = 1000000;
           parserObject_categoriesList.splice(0, 0, aCategory);//insert at index 0
           popularFound = true;
       }
    }

    this.setState({ "parserObject_categoriesList" : parserObject_categoriesList });
  }
  //----------------------------------------------------------------------------------------------------
  load_cookies_to_localStorage(){
    let methName = filename+"load_cookies_to_localStorage ";
    if(api.print_logs){console.log(methName);}

    try{
      console.log(methName+"Cookies.get(lang)       = "+Cookies.get('lang'));
      console.log(methName+"Cookies.get(isLoggedIn) = "+Cookies.get('isLoggedIn'));
      if(localStorage.getItem("isLoggedIn")==="true"){
        localStorage.setItem("transId",                       Cookies.get('transId'));       if(api.print_logs){console.log(methName+"transId      = "+localStorage.getItem("transId"));}
        console.log(methName+"localStorage is not wiped out");
        return;
      }
      localStorage.setItem("lang",                          Cookies.get('lang'));          if(api.print_logs){console.log(methName+"lang         = "+localStorage.getItem("lang"));}
      localStorage.setItem("isLoggedIn",                    Cookies.get('isLoggedIn'));    if(api.print_logs){console.log(methName+"isLoggedIn   = "+localStorage.getItem("isLoggedIn"));}
      localStorage.setItem("accessToken",                   Cookies.get('accessToken'));   if(api.print_logs){console.log(methName+"accessToken  = "+localStorage.getItem("accessToken"));}
      localStorage.setItem("refreshToken",                  Cookies.get('refreshToken'));  if(api.print_logs){console.log(methName+"refreshToken = "+localStorage.getItem("refreshToken"));}
      localStorage.setItem("tokenID",                       Cookies.get('tokenID'));       if(api.print_logs){console.log(methName+"tokenID      = "+localStorage.getItem("tokenID"));}
      localStorage.setItem("transId",                       Cookies.get('transId'));       if(api.print_logs){console.log(methName+"transId      = "+localStorage.getItem("transId"));}
      localStorage.setItem("billId",                        Cookies.get('billId'));        if(api.print_logs){console.log(methName+"billId       = "+localStorage.getItem("billId"));}
    } catch(err){
      console.log(methName+"err="+err);
    }
  }
  //----------------------------------------------------------------------------------------------------
  load_localStorage_to_cookies(){
    let methName = filename+"load_localStorage_to_cookies ";
    if(api.print_logs){console.log(methName);}

    try{ Cookies.remove('centralID',                            { path:api.webapp_path }); }catch(err){console.log(methName+"err="+err);}
    try{ Cookies.remove('TransferOnline1_PaymentMethod',        { path:api.webapp_path }); }catch(err){console.log(methName+"err="+err);}
    try{ Cookies.remove('TransferOnline1_TransferMethod',       { path:api.webapp_path }); }catch(err){console.log(methName+"err="+err);}
    try{ Cookies.remove('TransferOnline1_selCountry_ctry_wu_id',{ path:api.webapp_path }); }catch(err){console.log(methName+"err="+err);}
    try{ Cookies.remove('TransferOnline1_selCountry_ctry_wu_id',{ path:api.webapp_path }); }catch(err){console.log(methName+"err="+err);}
    try{ Cookies.remove('gross',                                { path:api.webapp_path }); }catch(err){console.log(methName+"err="+err);}
    try{ Cookies.remove('normalCharges',                        { path:api.webapp_path }); }catch(err){console.log(methName+"err="+err);}
    try{ Cookies.remove('expectedActualPayout',                 { path:api.webapp_path }); }catch(err){console.log(methName+"err="+err);}
    try{ Cookies.remove('rcv_curr',                             { path:api.webapp_path }); }catch(err){console.log(methName+"err="+err);}
    try{ Cookies.remove('principal',                            { path:api.webapp_path }); }catch(err){console.log(methName+"err="+err);}
    try{ Cookies.remove('rcv_fname',                            { path:api.webapp_path }); }catch(err){console.log(methName+"err="+err);}
    try{ Cookies.remove('rcv_lname',                            { path:api.webapp_path }); }catch(err){console.log(methName+"err="+err);}

    try{ Cookies.set('platform',                      "webapp-react",                                        {secure:true,expires:1,path:api.webapp_path}); }catch(err){console.log(methName+"err="+err);}
    try{ Cookies.set('lang',                          localStorage.getItem("lang"),                          {secure:true,expires:1,path:api.webapp_path}); }catch(err){console.log(methName+"err="+err);}
    try{ Cookies.set('isLoggedIn',                    "true",                                                {secure:true,expires:1,path:api.webapp_path}); }catch(err){console.log(methName+"err="+err);}
    try{ Cookies.set('accessToken',                   localStorage.getItem("accessToken"),                   {secure:true,expires:1,path:api.webapp_path}); }catch(err){console.log(methName+"err="+err);}
    try{ Cookies.set('refreshToken',                  localStorage.getItem("refreshToken"),                  {secure:true,expires:1,path:api.webapp_path}); }catch(err){console.log(methName+"err="+err);}
    try{ Cookies.set('tokenID',                       localStorage.getItem("tokenID"),                       {secure:true,expires:1,path:api.webapp_path}); }catch(err){console.log(methName+"err="+err);}
    try{ Cookies.set('transId',                       this.get_transId(),                                    {secure:true,expires:1,path:api.webapp_path}); }catch(err){console.log(methName+"err="+err);}
    try{ Cookies.set('billId',                        this.get_billId(),                                     {secure:true,expires:1,path:api.webapp_path}); }catch(err){console.log(methName+"err="+err);}
  }
  //----------------------------------------------------------------------------------------------------
  clear_cookies_not_needed(){
    let methName = filename+"clear_cookies_not_needed ";
    if(api.print_logs){console.log(methName);}

    try{
      //Cookies.remove('lang',                                  { path:api.webapp_path});
        Cookies.remove('isLoggedIn',                            { path:api.webapp_path});
        Cookies.remove('accessToken',                           { path:api.webapp_path});
        Cookies.remove('refreshToken',                          { path:api.webapp_path});
        Cookies.remove('tokenID',                               { path:api.webapp_path});
        Cookies.remove('transId',                               { path:api.webapp_path});
        Cookies.remove('billId',                                { path:api.webapp_path});
        Cookies.remove('bills_billsHistoryDetail_FLOW',         { path:api.webapp_path});
        Cookies.remove('bills_payWithCardMethod',               { path:api.webapp_path});
        Cookies.remove('bills_tokenizedPaymentMethod',          { path:api.webapp_path});
    } catch(err){
      console.log(methName+"err="+err);
    }
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------[goBack]------------------------------------------
  //----------------------------------------------------------------------------------------------------
  goBack(event) {
    let methName = filename+"goBack ";
    if(api.print_logs){console.log(methName);}

    localStorage.setItem("bills_billsHistoryDetail_FLOW","bills_billsHistoryDetail_FLOW_HISTORY");
    try{     Cookies.set('bills_billsHistoryDetail_FLOW',"bills_billsHistoryDetail_FLOW_HISTORY", {secure:true,expires:1,path:api.webapp_path}); }catch(err){console.log(methName+"err="+err);}

    this.clear_cookies_not_needed();

    //console.log("goBack "+localStorage.getItem("prev_view").trim());
    if(localStorage.getItem("prev_view").trim()==="BillsPaymentReview"){
      //+++++++++++++++
      //Goto Controller
      //+++++++++++++++
      //should be in comment//localStorage.setItem("BillsPaymentSetup_prev_view","BillsPaymentReview");
      history.push(wu_Utilities.getNavigationURLs("BillsPaymentSetup"));//sos changed last minute
    }
    else{
      //history.go(-1);
      history.goBack();
    }
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Popups--------------------------------------------
  //----------------------------------------------------------------------------------------------------
  dialog_handleOpen(dialog_msg,dType){
    if(dType==="NET"){
      setTimeout(function() {
        this.setState({
          "dialog_isOpen" : true,
          "dialog_msg"    : dialog_msg
        });
      }.bind(this), api.initialLoadGracePeriodMS);
      return;
    }
    this.setState({
      "dialog_isOpen" : true,
      "dialog_msg"    : dialog_msg
    });
  }
  dialog_handleClose(){
    this.setState({ "dialog_isOpen": false });
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Popups goBack-------------------------------------
  //----------------------------------------------------------------------------------------------------
  dialog_goBack_handleOpen(dialog_msg){
    setTimeout(function() {
      this.setState({
        "dialog_goBack_isOpen" : true,
        "dialog_goBack_msg"    : dialog_msg
      });
    }.bind(this), api.initialLoadGracePeriodMS);
    return;
  }
  //----------------------------------------------------------------------------------------------------
  dialog_goBack_btn_OK(){
    let methName = filename+"dialog_goBack_btn_OK ";
    if(api.print_logs){console.log(methName);}

    this.setState({ "dialog_goBack_isOpen": false });
    this.goBack(null);
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Popups gotoController-----------------------------
  //----------------------------------------------------------------------------------------------------
  dialog_gotoController_handleOpen(dialog_msg,dType){
    setTimeout(function() {
      this.setState({
        "dialog_gotoController_isOpen" : true,
        "dialog_gotoController_msg"    : dialog_msg
      });
    }.bind(this), api.initialLoadGracePeriodMS);
    return;
  }
  //----------------------------------------------------------------------------------------------------
  dialog_gotoController_btn_OK(){
    let methName = filename+"dialog_gotoController_btn_OK ";
    if(api.print_logs){console.log(methName);}

    this.setState({ "dialog_gotoController_isOpen": false });
    //+++++++++++++++
    //Goto Controller
    //+++++++++++++++
    history.push(wu_Utilities.getNavigationURLs("Bills"));
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------[SNACKBAR]----------------------------------------
  //----------------------------------------------------------------------------------------------------
  Snackbar_textField_handleOpen(msg){
    this.setState({
      "Snackbar_textField_open" : true,
      "Snackbar_textField_msg"  : msg,
    });
  }
  Snackbar_textField_handleClose(){
    this.setState({ "Snackbar_textField_open" : false });
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Spinners------------------------------------------
  //----------------------------------------------------------------------------------------------------
  startSpinners(){
    this.setState({ "viewPleaseWait_hidden" : false });
  }
  //----------------------------------------------------------------------------------------------------
  stopSpinners(){
    this.setState({ "viewPleaseWait_hidden" : true });
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------[Lockers]-----------------------------------------
  //----------------------------------------------------------------------------------------------------
  isLockersActive(){
    if( BillsPaymentReview_continue_locked===true ){ return true;  }
    else                                           { return false; }
    //if( localStorage.getItem(filename.trim()+"_continue_locked")==="true" ){ /*console.log("isLockersActive===true");*/  return true;  }
    //else                                                                   { /*console.log("isLockersActive===false");*/ return false; }
  }
  //----------------------------------------------------------------------------------------------------
  startLockers(){
    BillsPaymentReview_continue_locked = true;
    //localStorage.setItem(filename.trim()+"_continue_locked","true");
  }
  //----------------------------------------------------------------------------------------------------
  stopLockers(){
    BillsPaymentReview_continue_locked = false;
    //localStorage.setItem(filename.trim()+"_continue_locked","false");
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------DialogSpinner-------------------------------------
  //----------------------------------------------------------------------------------------------------
  dialog200_handleOpen(dialog_msg){
    this.setState({
      "dialog200_isOpen" : true,
      "dialog200_msg"    : dialog_msg
    });
  }
  //----------------------------------------------------------------------------------------------------
  dialog200_handleClose(){
    //this.setState({ "dialog200_isOpen": false });
    setTimeout(function() {
      this.setState({ "dialog200_isOpen": false });
    }.bind(this), api.initialLoadGracePeriodMS);
  }
  //----------------------------------------------------------------------------------------------------
  //----------------------------------------------------------------------------------------------------
}
BillsPaymentReview.propTypes = {
  classes: PropTypes.object.isRequired
};
function mapStateToProps(state) {
  const { alert }    = state;
  const { dispatch } = state;
  return {
    dispatch,
    alert
  };
}
export default connect(mapStateToProps)(
  withStyles(BillsPaymentReviewStyle)(BillsPaymentReview)
);
